<template>
  <div class="tv-pricing">
    <admin-view-header title="Pakiety TV">
      <div class="buttons">
        <protected :with="Permission.CREATE_TEMPLATE">
          <button class="button is-danger is-outlined" @click="resetForm">
            <icon name="fa-trash" />
            <span>Wyczyść</span>
          </button>
        </protected>
        <button class="button is-primary is-outlined" @click="showPreview">
          <icon name="fa-eye" />
          <span>Podgląd</span>
        </button>
        <protected :with="Permission.CREATE_TEMPLATE">
          <button
            class="button is-primary"
            @click="submit"
            :class="{ 'is-loading': submitting }"
            :disabled="submitting"
          >
            <icon name="fa-check" />
            <span>Zapisz</span>
          </button>
        </protected>
      </div>
    </admin-view-header>

    <pricing-input
      ref="pricing"
      :state="actions.templates"
      @update="updatePricing"
    />

    <loader :state="actions.templates">
      <div class="field">
        <label class="label">{{ FIELDS[T.TvOffer.PRICING_FOOTER] }}</label>
        <editor
          frame
          placeholder="Opcjonalny podpis do listy pakietów..."
          v-model="fields[T.TvOffer.PRICING_FOOTER]"
          :readonly="!hasPermission(Permission.CREATE_TEMPLATE)"
        />
      </div>
    </loader>
  </div>
</template>

<script>
import { Icon } from "%helpers";
import AdminViewHeader from "%admin/components/global/AdminViewHeader";
import PricingInput from "%admin/components/home/PricingInput";
import Editor from "%admin/components/global/Editor";

import {
  Protected,
  WithTemplates,
  WithUnsavedChangesConfirmation,
  WithPreview,
  WithReset
} from "%mixins";

import T from "%const/templates";

const FIELDS = {
  [T.TvOffer.PRICING]: "Pakiety TV",
  [T.TvOffer.PRICING_FOOTER]: "Podpis"
};

export default {
  name: "tv-pricing",

  components: {
    Icon,
    AdminViewHeader,
    PricingInput,
    Editor
  },

  mixins: [
    Protected,

    WithTemplates({
      templates: [T.TvOffer.PRICING, T.TvOffer.PRICING_FOOTER],
      json: [T.TvOffer.PRICING]
    }),

    WithUnsavedChangesConfirmation({
      checkChanges() {
        return (
          this.templatesLoaded() && this.areAnyTemplateChanges(this.fields)
        );
      },

      async onSave() {
        return await this.submit();
      }
    }),

    WithPreview({
      path: "/home",
      query: {
        step: "_tv-pricing"
      }
    }),

    WithReset(function() {
      this.initData();
    })
  ],

  data() {
    return {
      T,
      FIELDS,

      fields: {
        [T.TvOffer.PRICING]: null,
        [T.TvOffer.PRICING_FOOTER]: ""
      },

      submitting: false
    };
  },

  async mounted() {
    await this.requestTemplates();
    this.initData();
  },

  methods: {
    async submit() {
      return this.updateChangedTemplates(
        this.fields,
        FIELDS,
        () => (this.submitting = true),
        () => (this.submitting = false)
      );
    },

    initData() {
      this.applyTemplates(this.fields);
      this.$refs.pricing.setPricing(this.fields[T.TvOffer.PRICING]);
    },

    updatePricing(pricing) {
      this.fields[T.TvOffer.PRICING] = pricing;
    }
  }
};
</script>

<style></style>
